import styled from 'styled-components'

export const SurveyListContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	place-items: center;
	font-weight: 500;
	font-size: 16px;
	color: #64778f;
	padding: 20px 0;
	position: relative;
	left: 0;
	animation: fadeSlide 0.4s;

	@keyframes fadeSlide {
		0% {
			left: -70px;
			opacity: 0;
		}
		100% {
			opacity: 1;
			left: 0;
		}
	}
`

export const Title = styled.p`
	text-align: center;
`

export const TitleContainer = styled.div`
	display: grid;
	grid-template-columns: auto auto;
	gap: 8px;
	place-items: center;
	margin: 44px 0;

	svg:hover {
		cursor: pointer;
		color: #64778fcc;
	}
`
export const Description = styled.p`
	max-width: 390px;
	width: 100%;
	margin-bottom: 37px;
`

export const CardList = styled.div`
	margin-bottom: 70px;
	max-width: 390px;
	width: 100%;

	& > div {
		margin-bottom: 30px;
	}
`

export const ActionContainer = styled.div`
	max-width: 260px;
	width: 100%;
`

export const SurveyTipContainer = styled.div`
	display: grid;
	width: 100%;
	max-width: 590px;
	margin-bottom: 24px;

	li {
		margin-bottom: 16px;
	}
`

export const Paragraph = styled.p<{ fontWeight?: number }>`
	color: #64778f;
	margin-bottom: 24px;
	margin-left: 0px;
	font-weight: ${({ fontWeight }) => fontWeight ?? 'normal'};
`

export const OrderedList = styled.ol`
	margin-left: 18px;
`
export const Link = styled.a`
	text-decoration: none;
	font-weight: 500;
	color: #1ab0e6;
`
